var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.73557 12.3234C7.33403 10.5369 8.48902 8.98263 10.0358 7.88215C11.5825 6.78168 13.442 6.19126 15.349 6.19512C17.5106 6.19512 19.4651 6.95232 21 8.19159L25.4666 3.78598C22.7447 1.44498 19.2566 0 15.349 0C9.29887 0 4.0904 3.40486 1.58594 8.39225L6.73557 12.3234Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5164 22.732C19.1222 23.6192 17.352 24.0925 15.3489 24.0925C13.4495 24.0963 11.5971 23.5106 10.0538 22.4182C8.51046 21.3259 7.3545 19.7822 6.74957 18.0059L1.58203 21.8764C2.84993 24.4083 4.81208 26.5387 7.24563 28.0255C9.67917 29.5123 12.4866 30.296 15.3489 30.2876C19.1005 30.2876 22.6845 28.9713 25.3693 26.5016L20.5177 22.732H20.5164Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.37 26.5022C28.1776 23.9177 30.0003 20.0711 30.0003 15.1443C30.0003 14.2483 29.8609 13.2854 29.6524 12.3906H15.3496V18.2425H23.5819C23.1764 20.2099 22.0853 21.7332 20.5184 22.7327L25.37 26.5022Z",
    fill: "#4A90E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74992 18.0064C6.437 17.0838 6.27803 16.1172 6.27922 15.1442C6.27922 14.1574 6.4391 13.2096 6.73585 12.3237L1.58622 8.39258C0.532735 10.4909 -0.010335 12.8026 0.000148956 15.1442C0.000148956 17.5673 0.569345 19.8515 1.58239 21.877L6.74992 18.0064Z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.4774dfc7a297c78e5d6b81c1bee49555.svg";
export { ForwardRef as ReactComponent };